import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import {
  hideNoGratuityModal,
  submitFormCreate,
  submitFormCreateAllOutlets,
} from 'actions/library/salesType';
import styles from './NoGratuityModal.css';

class NoGratuityModal extends React.Component {
  render() {
    const { NoGratuityModal, disableHideOnOuterModal } = this.props;
    return (
      <Modal
        onHide={
          disableHideOnOuterModal
            ? function() {
                /* no op */
              }
            : this._onHide
        }
        show={NoGratuityModal.show}
        dialogClassName={`${styles.dialog} modal-dialog`}
      >
        <Modal.Header className={styles.header}>
          <button
            onClick={this._onHide}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <Modal.Title className={styles['title-modal']}>
            Create Sales Type
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Are you sure want to create sales type without assign gratuity{'?'}{' '}
            Gratuity will not be applied to any transaction by this sales type
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              className={`btn btn-default ${styles['no-button']}`}
              onClick={this._onHide}
            >
              No
            </button>
            <button
              type="button"
              className={`btn btn-primary ${styles['yes-button']}`}
              onClick={this._onClickYes}
            >
              Yes
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  _onHide = () => {
    const { dispatch } = this.props;
    dispatch(hideNoGratuityModal());
  };

  _onClickYes = () => {
    const {
      dispatch,
      STForm,
      NoGratuityModal,
      salesType,
      businessId,
      outletForm,
      outlets,
    } = this.props;
    [STForm.outlet_id] = outletForm.outletIds;
    STForm.name = STForm.name.trim();
    if (NoGratuityModal.action) {
      if (NoGratuityModal.action === 'save') {
        dispatch(submitFormCreate(STForm, businessId, salesType));
      } else {
        dispatch(
          submitFormCreateAllOutlets(STForm, businessId, salesType, outlets)
        );
      }
    }
    dispatch(hideNoGratuityModal());
  };
}

function mapStateToProps(state) {
  const { NoGratuityModal, salesType, outlets } = state.library.salesType;
  const businessId = state.moka.user.business.id;
  const outletForm = getFormValues('search')(state);
  return {
    STForm: getFormValues('salesType')(state),
    NoGratuityModal,
    salesType,
    businessId,
    outletForm,
    outlets,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoGratuityModal);
